// CSV export + import helpers (Excel-compatible)

export function downloadCSV(rows, columns, filename = "export.csv") {
  if (!rows || rows.length === 0) return;
  const headers = columns.map((c) => c.label);
  const keys = columns.map((c) => c.key);
  const escape = (v) => {
    if (v == null) return "";
    const s = String(v).replace(/"/g, '""');
    return /[,"\n]/.test(s) ? `"${s}"` : s;
  };
  const lines = [headers.join(",")];
  for (const row of rows) {
    const vals = keys.map((k) => {
      const col = columns.find((c) => c.key === k);
      let v = col?.csv ? col.csv(row) : row[k];
      if (typeof v === "object" && v !== null) v = JSON.stringify(v);
      return escape(v);
    });
    lines.push(vals.join(","));
  }
  // Excel BOM for utf-8
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function parseCSV(text) {
  // Robust CSV parser handling quotes and commas
  const lines = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch === '"') {
      if (inQuotes && text[i + 1] === '"') { cur += '"'; i++; }
      else inQuotes = !inQuotes;
    } else if (ch === "\n" && !inQuotes) {
      lines.push(cur);
      cur = "";
    } else if (ch === "\r" && !inQuotes) {
      // ignore
    } else cur += ch;
  }
  if (cur) lines.push(cur);

  const parseLine = (line) => {
    const cells = [];
    let c = "";
    let q = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') {
        if (q && line[i + 1] === '"') { c += '"'; i++; }
        else q = !q;
      } else if (ch === "," && !q) {
        cells.push(c); c = "";
      } else c += ch;
    }
    cells.push(c);
    return cells;
  };

  const rows = lines.filter((l) => l.trim().length > 0).map(parseLine);
  if (rows.length === 0) return [];
  const headers = rows[0].map((h) => h.trim());
  return rows.slice(1).map((r) => {
    const o = {};
    headers.forEach((h, i) => { o[h] = (r[i] ?? "").trim(); });
    return o;
  });
}
